<div class="dialog-header">
  <h2 mat-dialog-title>{{ 'updateDeliveredVolumeDialog.title' | translate }}</h2>
  <button mat-icon-button (click)="close()" class="close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <div class="app-info">
    <p><strong>{{ 'updateDeliveredVolumeDialog.supplierName' | translate }}:</strong> {{ data.volume.applicantName }}</p>
    <p><strong>{{ 'updateDeliveredVolumeDialog.meatType' | translate }}:</strong> {{ getMeatTypeName(data.volume.meatType) }}</p>
    <p><strong>{{ 'updateDeliveredVolumeDialog.year' | translate }}:</strong> {{ data.volume.quotaYear }}</p>
  </div>

  <form class="form-content">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>ПИН</mat-label>
      <input matInput [ngModel]="personIdnp" name="personIdnp"
             inputmode="numeric" maxlength="14"
             (input)="onNumericInput($event, 'personIdnp')"
             (keydown)="onKeyDown($event)">
    </mat-form-field>
    @if (fieldErrors()['personIdnp']) {
      <div class="field-error">{{ fieldErrors()['personIdnp'] }}</div>
    }

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>ИНН организации</mat-label>
      <input matInput [ngModel]="organizationInn" name="organizationInn"
             inputmode="numeric" maxlength="14"
             (input)="onNumericInput($event, 'organizationInn')"
             (keydown)="onKeyDown($event)">
    </mat-form-field>
    @if (fieldErrors()['organizationInn']) {
      <div class="field-error">{{ fieldErrors()['organizationInn'] }}</div>
    }

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{ 'updateDeliveredVolumeDialog.deliveredVolume' | translate }}</mat-label>
      <input matInput type="number" [(ngModel)]="deliveredVolume" name="deliveredVolume" min="0.001" step="0.001" required>
      <mat-hint>{{ 'updateDeliveredVolumeDialog.volumeHint' | translate }}</mat-hint>
    </mat-form-field>
  </form>

  @if (errorMessage()) {
    <div class="error-message">{{ errorMessage() }}</div>
  }
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions">
  <button mat-button (click)="close()">{{ 'updateDeliveredVolumeDialog.cancel' | translate }}</button>
  <button mat-raised-button color="primary"
          (click)="submit()"
          [disabled]="!isFormValid() || loading()">
    @if (loading()) {
      <mat-spinner diameter="20"></mat-spinner>
    } @else {
      {{ 'updateDeliveredVolumeDialog.save' | translate }}
    }
  </button>
</mat-dialog-actions>
